import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";

export default function EventUpdate() {
  const [title, setTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [content, setContent] = useState("");
  const [location, setLocation] = useState("");
  const [image, setImage] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const handleEditorChange = (value) => setContent(value);

  // Fetch existing event data
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const res = await axios.get(
          `https://m1blog.aaragroups.com/blog/api/admin/api/event_list_api/?event_id=${id}`,
          {
            headers: {
              token: localStorage.getItem("token"),
            },
          },
        );

        const eventData = res.data?.data;
        if (eventData) {
          setTitle(eventData.Title || "");
          setMetaKeyword(eventData.meta_keyword || "");
          setMetaDescription(eventData.meta_description || "");
          setContent(eventData.Content || "");
          setLocation(eventData.location || "");
          setStartDate(eventData.start_date || "");
          setEndDate(eventData.end_date || "");
          // Optional: set existing image if you have a URL
          // setImage(eventData.image_url || null);
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to fetch event data",
        );
      }
    };

    fetchEvent();
  }, [id]);

  const updateEvent = async (e) => {
    e.preventDefault();

    if (!title || !content || !startDate || !endDate) {
      toast.error("Please fill all required fields");
      return;
    }

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("meta_keyword", metaKeyword);
    formData.append("meta_description", metaDescription);
    formData.append("Content", content);
    formData.append("location", location);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    if (image) formData.append("images", image);

    try {
      const res = await axios.put(
        `https://m1blog.aaragroups.com/blog/api/admin/api/event_deatils_api/?id=${id}`,
        formData,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        },
      );

      if (res?.data?.response_code === 200) {
        toast.success(res.data.message);
        navigate("/event");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Some error occurred");
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="mt-5 bg-white shadow-lg px-5 rounded-md">
        <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
          Update Event
        </p>
        <form onSubmit={updateEvent}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Title */}
            <div>
              <p className="p-1 text-sm font-semibold">Title</p>
              <input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Event Title"
              />
            </div>

            {/* Meta Description */}
            <div>
              <p className="p-1 text-sm font-semibold">Meta Description</p>
              <input
                value={metaDescription}
                onChange={(e) => setMetaDescription(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Meta Description"
              />
            </div>

            {/* Meta Keyword */}
            <div>
              <p className="p-1 text-sm font-semibold">Meta Keyword</p>
              <input
                value={metaKeyword}
                onChange={(e) => setMetaKeyword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Meta Keyword"
              />
            </div>

            {/* Event Start Date */}
            <div>
              <p className="p-1 text-sm font-semibold">Event Start Date</p>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            {/* Event End Date */}
            <div>
              <p className="p-1 text-sm font-semibold">Event End Date</p>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            {/* Location */}
            <div>
              <p className="p-1 text-sm font-semibold">Location</p>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Event Location"
              />
            </div>

            {/* Image */}
            <div>
              <p className="p-1 text-sm font-semibold">Event Image</p>
              <ImagePicker placeholder="Input Image" handleChange={setImage} />
            </div>
          </div>

          {/* Content */}
          <div className="mt-4">
            <p className="p-1 text-sm font-semibold">Content</p>
            <ReactQuill
              value={content}
              onChange={handleEditorChange}
              className="w-full bg-gray-100 border border-gray-300 rounded"
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center mt-5 mb-5">
            <Button type="submit" variant="contained" color="primary">
              Update Event
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
